<template>
  <div>
    <div class="title-content">
      <Panel>
        <FormItemLabel class="title-input" label="キャンペーンタイトル" required />

        <el-input
          :value="form.title"
          placeholder="キャンペーンタイトル"
          size="normal"
          @input="setFormTitle"
          @blur="change"
        />

        <div v-if="is_title_empty" class="title-input-error">キャンペーンタイトルを入力してください。</div>

        <div v-if="is_title_max_length" class="title-input-error">
          キャンペーンタイトルは50文字以下に設定してください。
        </div>
      </Panel>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Panel from '@/client/components/_atoms/Panel.vue'
import FormItemLabel from '@/client/components/_molecules/FormItemLabel.vue'
import { TrackingService } from '@/client/services'
import { CampaignForm, useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'

export default defineComponent({
  components: { FormItemLabel, Panel },
  computed: {
    ...mapState(useCampaignDialogStore, ['form']),
    is_title_empty() {
      const vm = this as typeof this & { form: CampaignForm }
      return this.is_change && !vm.form.title.trim()
    },
    is_title_max_length() {
      const vm = this as typeof this & { form: CampaignForm }
      return !!vm.form.title.trim() && vm.form.title.trim().length > 50
    }
  },
  data() {
    return {
      is_change: false
    }
  },
  methods: {
    ...mapActions(useCampaignDialogStore, ['setForm']),
    /**
     * 変化
     */
    change() {
      this.is_change = true
    },

    /**
     * フォームタイトルを設定
     */
    async setFormTitle(value: string) {
      const vm = this as typeof this & {
        form: CampaignForm
        setForm: (form: CampaignForm) => Promise<void>
      }

      TrackingService.sendEvent('input:キャンペーンの新規作成|タイトル|キャンペーンタイトル')

      this.change()

      await vm.setForm({ ...vm.form, title: value })
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.title-input {
  margin-bottom: $spacing-unit;
}

.title-input-error {
  margin-top: $spacing-unit;
  color: $danger-color;
}

.title-button {
  display: flex;
  justify-content: flex-end;
  margin-top: $spacing-unit * 3;
}
</style>
